import React, { PropTypes } from 'react';

import {
    CATEGORIES,
    MEDIUMS,
} from '../../utils/category-utils';

import StoryItem from '../story-item/story-item';


const StoryList = ({stories, currentCategory, currentFilteredCategory, currentMedium}) => {
  // Get the indices of the stories that fit the current category.
  // We show ranks by their position in the original array, not the filtered array,
  // so we need the filtered items' original indices.
  const originalIndices = stories.map((story, i) => i);
  const filteredIndices = originalIndices.filter((index) => {
    if (!currentCategory) { return true; }
    if (!stories[index].categories || !stories[index].categories.length) { return false; }
    for (var j = 0; j < stories[index].categories.length; j++) {
      if (stories[index].categories[j] === currentCategory.className) {
        return true;
      }
    }
    return false;
  })

  //const isFaded = (story) => {
  //  return false;

  //   Commented out because it feels broken since the first 6 are all politics
  //  if (currentCategory || !currentFilteredCategory) {
  //    return false;
  //  }
  //  for (var i = 0; i < story.categories.length; i++) {
  //    if (story.categories[i] === currentFilteredCategory.className) {
  //      return false;
  //    }
  //  }
  //  return true;
  //}

  const isHighlighted = (story) => {
    if (!story.medium || !currentMedium) {
        return false;
    }
    if (story.medium === currentMedium.className) {
        return true;
    }
    return false;
  }

  return (
    <div>
      {filteredIndices.map((index) => {
        return <StoryItem
          key={stories[index].title}
          rank={index + 1}
          title={stories[index].title}
          publisher={stories[index].publisher}
          authors={stories[index].authors}
          categories={stories[index].categories}
          medium={stories[index].medium || null}
          image={stories[index].img}
          url={stories[index].url}
          //fade={isFaded(stories[index])}
          highlightMedium={isHighlighted(stories[index])}
        />
      })}
    </div>
  )
}

StoryList.propTypes = {
  stories: PropTypes.array.isRequired,
  currentCategory: PropTypes.oneOf(CATEGORIES),
  currentFilteredCategory: PropTypes.oneOf(CATEGORIES),
  currentMedium: PropTypes.oneOf(MEDIUMS),
}

export default StoryList;



// WEBPACK FOOTER //
// ./src/components/story-list/story-list.js